import { useContext, useState } from "react";
import {
  Alpha1Set,
  Area1Set,
  Color1Set,
  Ratio1Set,
  Ratio2Set,
  Shikii1Set,
} from "../App";
import { HanreiColorpallet } from "./hanreiColorpallet";
import { HanreiHigh } from "./hanreiHigh";

export function ModalColorset({ metadata, show, setShow }) {
  const { area1set } = useContext(Area1Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { color1set, setColor1Set } = useContext(Color1Set);
  const { shikii1set, setShikii1Set } = useContext(Shikii1Set);

  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { ratio2set, setRatio2Set } = useContext(Ratio2Set);

  const [col1, setCol1Set] = useState(metadata.hanrei1_color);
  const [col2, setCol2Set] = useState(metadata.hanrei2_color);
  const [col3, setCol3Set] = useState(metadata.hanrei3_color);
  const [col4, setCol4Set] = useState(metadata.hanrei4_color);
  const [col5, setCol5Set] = useState("ffffff");

  // useDidUpdateEffect(()=>{
  //   setColor1Set([col1,col2,col3,col4,col5])
  // },[col1,col2,col3,col4,col5])

  const setcol1 = (value) => {
    setCol1Set(value);
  };
  const setcol2 = (value) => {
    setCol2Set(value);
  };
  const setcol3 = (value) => {
    setCol3Set(value);
  };
  const setcol4 = (value) => {
    setCol4Set(value);
  };
  function pickerClicker1(e) {
    document.getElementById("bar1Picker").click();
  }
  function pickerClicker2(e) {
    document.getElementById("bar2Picker").click();
  }
  function pickerClicker3(e) {
    document.getElementById("bar3Picker").click();
  }
  function pickerClicker4(e) {
    document.getElementById("bar4Picker").click();
  }

  {
    /* https://brandcolors.net/ */
  }
  const color_preset = [
    ["Burger King", "#ec1c24", "#fdbd10", "#0066b2", "#ed7902"],
    ["Courtyard", "#689550", "#85c446", "#c0de9e", "#b9dca4"],
    ["Heineken", "#008200", "#205527", "#ff2b00", "#c3c3c3"],
    ["Google", "#ea4335", "#34a853", "#fbbc05", "#4285f4"],
    ["Microsoft", "#f65314", "#7cbb00", "#00a1f1", "#ffbb00"],
    ["Rolls-Royce", "#680021", "#fffaec", "#939598", "#000000"],
    ["The Ritz-Carlton", "#006b95", "#4f5b65", "#a01a1f", "#b3812a"],
    ["Toyota", "#eb0a1e", "#ffffff", "#000000", "#58595b"],
    ["Wikipedia", "#000000", "#636466", "#939598", "#c7c8ca"],
    ["Booking.com", "#003580", "#009fe3", "#feba02", "#666"],
    ["CNN", "#cc0000", "#000000", "#282828", "#464646"],
    ["eBay", "#e53238", "#0064d2", "#f5af02", "#86b817"],
    ["Gucci", "#8f1010", "#204030", "#a11826", "#0f403f"],
    ["Hulu", "#66aa33", "#99cc33", "#41811e", "#222222"],
    ["Slack", "#6ecadc", "#e9a820", "#e01563", "#3eb991"],
    ["Twitter", "#1da1f2", "#14171a", "#657786", "#aab8c2"],
    ["UC Berkeley", "#003262", "#3b7ea1", "#fdb515", "#c4820e"],
    ["University of Victoria", "#005493", "#f5aa1c", "#c63527", "#002754"],
  ];

  const precolorset = (color) => {
    // console.log("クリック！");
    setColor1Set([color[1], color[2], color[3], color[4], col5]);
  };

  // console.log(color_preset[0][2]);

  // {/* https://colordrop.io/popular/ */}
  // #de4307-#f29c2b-#f6d04d-#8bc24c
  // #616536-#A4E666-#31B96E-#1B1112
  // #DD4E00-#F78500-#F9C134-#F0F4C1
  // #f6c2c2-#f9fbba-#e2f2d5-#d4edf4
  // #668b8a-#9fb083-#f9eed3-#a47c64

  if (show) {
    return (
      <>
        <div
          id="overlay"
          onClick={() => setShow(false)}
          className="flex items-center top-0 left-0 w-screen"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="text-black bg-gradient-to-r from-white/100 to-white/70 font-medium rounded-lg mx-auto w-5/6 h-screen overflow-y-auto"
          >
            <div
              onClick={() => setShow(false)}
              className="flex justify-end mt-2 mr-2 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>

            <HanreiHigh metadata={metadata} />

            <div className="bg-gray-200 pb-5">
              <h2 className="text-xl py-5 text-left">
                プリセットカラーから選ぶ
              </h2>

              <div className="text-black flex flex-wrap">
                {color_preset.map((color,index) => (
                    <div className="w-1/12" key={index} onClick={() => precolorset(color)}>
                      <HanreiColorpallet color={color} />
                    </div>
                ))}
              </div>
            </div>

            <div className="text-black bg-blue-200 py-2 m-3 border-4 rounded-xl">
              {`${color1set[0]}-${color1set[1]}-${color1set[2]}-${color1set[3]}_${shikii1set[0]}-${shikii1set[1]}-${shikii1set[2]}`}
            </div>

            {/* <table className="mx-5">
               <tbody>
                 <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                   <td colSpan={3} className="py-4 px-6 text-sm font-medium whitespace-nowrap break-words">
                     {metadata.kml_ok == 1 && <>
                       <Csv2kml
                         meta = {metadata}
                         area = {area1set}
                         ratio = {ratio1set}
                         alpha = {0.9}
                         >
                           <span className="text-blue-500 underline">
                         KMLダウンロード
                           </span>
                       </Csv2kml>
                     </>}
                   </td>
                 </tr>
               </tbody>
             </table> */}

            <div className="flex justify-center md:my-5 cursor-pointer">
              <div onClick={() => setShow(false)}>閉じる</div>
            </div>

            <></>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}

// export function Syosai(props) {
//   console.log(props);
//   const metadata = props.metadata;
//   const { area1set, setArea1Set } = useContext(Area1Set);

//   return (

//   );
// }
